var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// The gw-pl-accordion-group directive indicates a block of html that will expand and collapse in an accordion

import templateStr from 'text!edge/platform/widgets/accordion/directives/templates/accordion-group.html';

export default [function () {
    return {
        require: ['^gwPlAccordion', 'gwPlAccordionGroup'], // We need this directive to be inside an accordion
        restrict: 'EA',
        transclude: true, // It transcludes the contents of the directive into the template
        replace: true, // The element containing the directive will be replaced with the template
        template: templateStr,
        scope: {
            gwPlHeading: '@', // Interpolate the heading attribute onto this scope
            isOpen: '=?',
            initialIsOpen: '&',
            initialScrollToOpen: '&',
            isDisabled: '=?',
            validationForm: '=',
            flavor: '@'
        },
        controller: ['$scope', '$element', '$rootElement', function ($scope, $element, $rootElement) {
            var _this = this;

            this.initialScroll = function () {
                if ($scope.initialScrollToOpen() && $scope.isOpen) {
                    $scope.$applyAsync(function () {
                        $rootElement.scrollTop($element.offset().top);
                    });
                }
            };

            this.setHeading = function (element) {
                _this.gwPlHeading = element;
            };
        }],
        link: function link(scope, element, attrs, ctrls, transcludeFn) {
            var _ctrls = _slicedToArray(ctrls, 2),
                accordionCtrl = _ctrls[0],
                accordionGroupCtrl = _ctrls[1];

            if (typeof scope.initialIsOpen() !== 'undefined') {
                scope.isOpen = scope.initialIsOpen();
            }
            accordionGroupCtrl.initialScroll();

            transcludeFn(function (clonedMarkup, childScope) {
                element.find('[transclude-here]').append(clonedMarkup);
                childScope.isAccordionOpen = function () {
                    return scope.isOpen;
                };
            });

            scope.flavor = scope.flavor || 'default';
            accordionCtrl.addGroup(scope);

            scope.$watch('isOpen', function (value) {
                if (value) {
                    accordionCtrl.closeOthers(scope);
                }
            });

            scope.toggleOpen = function () {
                if (!scope.isDisabled) {
                    scope.isOpen = !scope.isOpen;
                }
            };
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/accordion/directives/accordionGroup.js
// module id = 1936
// module chunks = 0